import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
    const { currentUser, ready } = useAuth();

    if (!ready) return null;

    return currentUser ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;